import useTable from "@organisms/Table/Table.context"
import ViewBar from "@organisms/ViewBar/ViewBar"

import { TableViewTabsProps } from "./TableViewTabs.types"

export default function TableViewTabs(props: TableViewTabsProps) {
    const { children } = props

    const { activePhase } = useTable()

    return <ViewBar.Tabs activePhase={activePhase}>{children}</ViewBar.Tabs>
}
